export var KnowledgeSourceType;
(function (KnowledgeSourceType) {
    KnowledgeSourceType["DOCUMENT"] = "document";
    KnowledgeSourceType["URL"] = "url";
    KnowledgeSourceType["SCREENSHOT"] = "screenshot";
    KnowledgeSourceType["SCREEN_RECORDING"] = "screen_recording";
    KnowledgeSourceType["BATTLECARD"] = "battlecard";
    KnowledgeSourceType["DEMO_SCRIPT"] = "demo_script";
    KnowledgeSourceType["TALKING_POINT"] = "talking_point";
})(KnowledgeSourceType || (KnowledgeSourceType = {}));
export var KnowledgeSourceStatus;
(function (KnowledgeSourceStatus) {
    KnowledgeSourceStatus["PENDING"] = "pending";
    KnowledgeSourceStatus["PROCESSING"] = "processing";
    KnowledgeSourceStatus["INDEXED"] = "indexed";
    KnowledgeSourceStatus["FAILED"] = "failed";
})(KnowledgeSourceStatus || (KnowledgeSourceStatus = {}));
//# sourceMappingURL=knowledge.js.map